var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { forEach } from 'lodash';
import getAllAssetIcons from '../../requests/asset/getAllAssetIcons';
import Command from '../Command';
/**
 *
 */
var GetAllAssetIconsCommand = /** @class */ (function (_super) {
    __extends(GetAllAssetIconsCommand, _super);
    function GetAllAssetIconsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param iconDictionary AssetModel
     * @param organisationId string
     * @return {*}
     */
    GetAllAssetIconsCommand.prototype.execute = function (organisation) {
        this.iconDictionary = new Map;
        var orgId = organisation.id;
        var promise = getAllAssetIcons(orgId);
        promise.then(this.then).finally();
        return this.iconDictionary;
    };
    /**
    *
    * @param response
    */
    GetAllAssetIconsCommand.prototype.then = function (response) {
        var _this = this;
        var prefix = window.iconUrlPrefix || response.urlPrefix;
        forEach(response.icons, function (url, name) {
            _this.iconDictionary.set(name, (prefix + url));
        });
    };
    return GetAllAssetIconsCommand;
}(Command));
export default GetAllAssetIconsCommand;
